import { auth } from '../../firebase';
import { queueForSessionReady } from '../providers/provider-utils';
import { productsByCategoryEndpoint } from '../../constants/api-endpoints';
import { trackEvent } from '../analytics/tracking';

// Last resort fallback category
export const DEFAULT_PRODUCT_CATEGORY = { 
  name:'vaporizers', 
  display_name:'Vaporizers'
};

export const parseCategoryFromParam = (param, productCategories) => {
  if (!productCategories.length) {
    return DEFAULT_PRODUCT_CATEGORY;
  } else {
    const category = productCategories.find(cat => cat.display_name === param);
    return category || DEFAULT_PRODUCT_CATEGORY;
  }
};

/**
 * For Shop by Product
 * 
 * @param {string} categoryName - name of category data to fetch 
 * @param {string} zipCode - optional zip code scoping 
 * @param {function} callback 
 * @param {AbortController} controller 
 */
export const fetchProductsByCategory = async (categoryName, deliveryZipCode, callback, controller) => {
  const productCategoryRequest = (category_name, delivery_zip_code, callback, controller) => {
    if (auth.currentUser) {
      /* enable inactive products in dev */
      const params = {
        category_name,
        include_inactive: !!window.tests_enabled
      };
      if (delivery_zip_code) {
        params.delivery_zip_code = delivery_zip_code;
      }
      const paramString = new URLSearchParams(params).toString();
      auth.currentUser.getIdToken(/* no need to force refresh */ false).then(function(idToken) {
        const productCategoryEndpoint = `${productsByCategoryEndpoint}?${paramString}`; 
        fetch(productCategoryEndpoint, {
          method: 'GET',
          headers: {
            'Authorization': idToken
          },
          signal: controller.signal
        }).then(response => response.json())
          .then(data => callback(data))
          .catch(error => console.log(error)); 
      });
    }
  };
  
  try {
    // any user ok for this
    if (typeof auth === 'undefined' || !auth.currentUser) {
      queueForSessionReady(() => {
        productCategoryRequest(categoryName, deliveryZipCode, callback, controller);
      });
    } else {  
      productCategoryRequest(categoryName, deliveryZipCode, callback, controller);
    }
  } catch(error) {
    trackEvent('error_requesting_products_by_category', error);
    console.log('product category fetch failed');
  }    
};

/**
 * The api/public/products search results are returned by dispensary in a single array.
 *
 * We'll build a map { dispId : [products] } 
 *
 * @param {array} response - api response data 
 */ 
export const mapByDispensary = (response) => {
  const mappedResults = {};
  while (response.length && response.length > 0) {
    const dispId = response[0].dispensary.id;
    const dispProducts = [];
    while(response.length && dispId === response[0].dispensary.id) {
      dispProducts.push(response.shift());   
    }
    mappedResults[dispId] = dispProducts;
  }
  return mappedResults;
} 

/**
 * Get the category name from the display name
 * 
 * @param {string} displayName - The category display name "Pre Rolls" etc.
 * @param {array} productCategories - The array of category objects from redux
 */
export const getCategoryNameFromDisplayName = (displayName, productCategories) => {
  const [ category ] = productCategories.filter((catItem) => {
    return catItem.display_name === displayName;    
  })  
  return category.name;
}

/**
 * Get a category object item for a specific category(name)
 * 
 * @param {string} categoryName - The category display name "Flower" etc.
 * @param {string} item - The object item ( display_name, image_url, etc. ) from the category
 * @param {array} productCategories - The array of category objects from redux
 */
 export const getCategoryInfoItem = (categoryName, item, productCategories) => {
  const category = productCategories.find((catItem) => {
    return catItem.display_name === categoryName;    
  })  
  return category[item];
}
